import { Link } from 'react-router-dom';
import { Users, GraduationCap, BarChart3, ShieldCheck, Megaphone, ArrowRight } from 'lucide-react';
import PageHero from '../../components/public/PageHero';
import Reveal from '../../components/public/Reveal';
import { BENEFITS, MODULES } from '../../lib/constants';

const ICONS = { Users, GraduationCap, BarChart3, ShieldCheck, Megaphone };

export default function Beneficios() {
  return (
    <div>
      <PageHero
        eyebrow="Beneficios"
        title="Ser socio CNIB es multiplicar tus oportunidades"
        description="Red de contactos, formación, tecnología y respaldo institucional: todo lo que un profesional inmobiliario necesita para crecer."
      />

      <section className="py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {BENEFITS.map((b, i) => {
              const Icon = ICONS[b.icon];
              return (
                <Reveal key={b.title} delay={i * 0.08}>
                  <div className="group h-full rounded-3xl border border-slate-100 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-cnib-blue/10 transition-colors duration-300 group-hover:bg-orange-500/10">
                      <Icon className="h-7 w-7 text-cnib-blue transition-colors duration-300 group-hover:text-orange-500" />
                    </div>
                    <h3 className="mt-5 font-heading text-xl font-bold text-slate-900">{b.title}</h3>
                    <p className="mt-3 leading-relaxed text-slate-600">{b.text}</p>
                  </div>
                </Reveal>
              );
            })}
            <Reveal delay={0.4}>
              <div className="flex h-full flex-col justify-between rounded-3xl bg-cnib-navy p-8">
                <div>
                  <h3 className="font-heading text-xl font-bold text-white">¿Listo para unirte?</h3>
                  <p className="mt-3 leading-relaxed text-slate-300">
                    Completa tu solicitud en minutos y forma parte de la red inmobiliaria más grande de Bolivia.
                  </p>
                </div>
                <Link
                  to="/hagase-socio"
                  data-testid="beneficios-cta-hagase-socio"
                  className="group mt-6 inline-flex w-fit items-center gap-2 rounded-full bg-orange-500 px-6 py-3 font-bold text-white transition-all duration-300 hover:bg-orange-600"
                >
                  Hágase socio
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-500">Incluido en tu membresía</p>
            <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Módulos de CNIB Connect
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {MODULES.map((m, i) => (
              <Reveal key={m.id} delay={(i % 5) * 0.06}>
                <div className="h-full rounded-2xl bg-slate-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                  <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-500">{m.tag}</span>
                  <h3 className="mt-1 font-heading text-sm font-bold text-slate-900">{m.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-slate-600">{m.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
